import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromPortfolio from './portfolio.reducer';

export const selectPortfolioState = createFeatureSelector<fromPortfolio.PortfolioState>(
  fromPortfolio.portfolioFeatureKey
);

export const selectPortfolios = createSelector(selectPortfolioState, portfolioState => portfolioState.portfolioItems);

export const selectPortfoliosLoading = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.portfolioItemsLoading
);

export const selectPortfolioDetails = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.portfolioDetails
);
export const selectPortfolioDetailsLoading = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.portfolioDetailsLoading
);

export const selectPropertyDetails = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.propertyDetails
);
export const selectPropertyDetailsLoading = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.propertyDetailsLoading
);
export const selectPropertyDetailsUpdateOngoing = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.propertyDetailsUpdateOngoing
);

export const selectProperties = createSelector(selectPortfolioState, portfolioState => portfolioState.userProperties);

export const selectPropertiesLoading = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.userPropertiesLoading
);

export const selectPortfolioUpdate = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.portfolioUpdateOngoing
);

export const selectPortfolioNewPropertyUpdateOngoing = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.portfolioNewPropertyUpdateOngoing
);
export const selectPortfolioRemovePropertyUpdateOngoing = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.portfolioRemovePropertyUpdateOngoing
);

export const selectPortfolioDeleteOngoing = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.deletePortfolioOngoing
);

export const selectUnassignedProperties = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.unassignedProperties
);

export const selectUnassignedPropertiesLoading = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.unassignedPropertiesLoading
);

export const selectAllPropertyManagers = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.allPropertyManagers
);

export const selectAllPropertyManagersLoading = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.allPropertyManagersLoading
);
export const selectPropertyManagersForProperty = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.propertyManagersForProperty
);

export const selectPropertyManagersForPropertyLoading = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.propertyManagersForPropertyLoading
);
export const selectPropertyUnits = createSelector(selectPortfolioState, portfolioState => portfolioState.propertyUnits);

export const selectPropertyUnitsLoading = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.propertyUnitsLoading
);

export const selectUnitAttachments = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.unitAttachments
);

export const selectUnitAttachmentsLoading = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.unitAttachmentsLoading
);

export const selectDeleteUnitAttachmentInProgress = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.deleteUnitAttachmentInProgress
);

export const selectDeleteUnitAttachmentStatus = createSelector(
  selectPortfolioState,
  portfolioState => portfolioState.deleteUnitAttachmentStatus
);
